import clsx from 'clsx';
import type { CSSProperties, InputHTMLAttributes } from 'react';
import { MdCheckCircleOutline, MdErrorOutline } from 'react-icons/md';
import { styled } from 'styled-components';
import { FuuzeColors } from '../styles/colors.js';
import { FuuzeLoading } from './fuuze-loading.js';

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  flex: 1;
`;

const iconStyle: CSSProperties = {
  marginLeft: -25,
  marginRight: 10,
};

export type FuuzeInputProps = InputHTMLAttributes<HTMLInputElement> & {
  error?: boolean;
  valid?: boolean;
  loading?: boolean;
  ref?: any;
};

export function FuuzeInput({ error, valid, loading, ref, style, ...props }: FuuzeInputProps) {
  return (
    <Wrapper>
      <input
        {...props}
        ref={ref}
        className={clsx({ error, valid, 'fuuze-input': true })}
        style={{ flex: 1, paddingRight: 35, ...style }}
      />
      {!loading && error && <MdErrorOutline style={iconStyle} fill={FuuzeColors.red} />}
      {!loading && valid && <MdCheckCircleOutline style={iconStyle} fill={FuuzeColors.green} />}
      {loading && (
        <div style={iconStyle}>
          <FuuzeLoading $color='light' />
        </div>
      )}
    </Wrapper>
  );
}
